import { RefObject, useEffect, useRef } from 'react';
import { tracker } from 'src/utils/analytics';
import { useIntersectionObserver } from 'src/hooks/use-intersection-observer';

type UseLoyaltyPassImpressionTrackingProps = {
  type: 'button' | 'qrCode';
};

type UseLoyaltyPassImpressionTrackingReturn = {
  ref: RefObject<HTMLDivElement>;
};
export const useLoyaltyPassImpressionTracking = ({
  type,
}: UseLoyaltyPassImpressionTrackingProps): UseLoyaltyPassImpressionTrackingReturn => {
  const ref = useRef<HTMLDivElement>(null);

  const entry = useIntersectionObserver(ref, {
    threshold: 0.1,
    freezeOnceVisible: true,
  });

  useEffect(() => {
    if (entry?.isIntersecting) {
      tracker.walletPass({ action: 'viewed', type });
    }
  }, [entry?.isIntersecting, type]);

  return { ref };
};
